import { css } from '@emotion/react';
import { LoginModal } from '@inflearn/app-shell';
import { Box } from '@inflearn/ds-react-next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import type { ReactElement } from 'react';
import PlainLayout from '../../components/layout/PlainLayout/PlainLayout';
import AdvantagesSection from '../../components/pages/open-knowledge/AdvantagesSection';
import CtaSection from '../../components/pages/open-knowledge/CtaSection';
import FaqSection from '../../components/pages/open-knowledge/FaqSection';
import HeroSection from '../../components/pages/open-knowledge/HeroSection';
import KnowledgeTypesSection from '../../components/pages/open-knowledge/KnowledgeTypesSection';
import PainPointsSection from '../../components/pages/open-knowledge/PainPointsSection';
import ProcessSection from '../../components/pages/open-knowledge/ProcessSection';
import StatsSection from '../../components/pages/open-knowledge/StatsSection';
import TestimonialsSection from '../../components/pages/open-knowledge/TestimonialsSection';
import useViewJoinInstructorPageEvent from '../../components/pages/open-knowledge/hooks/useViewJoinInstructorPageEvent';
import { useLoginModalContext } from '../../providers/ControlLoginModalContextProvider';

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

function OpenKnowledgePage() {
  const { isOpened, close } = useLoginModalContext();
  useViewJoinInstructorPageEvent();

  return (
    <Box css={stylePage}>
      <HeroSection />
      <StatsSection />
      <PainPointsSection />
      <AdvantagesSection />
      <KnowledgeTypesSection />
      <ProcessSection />
      <TestimonialsSection />
      <CtaSection />
      <FaqSection />
      <LoginModal opened={isOpened} onClose={close} />
    </Box>
  );
}

OpenKnowledgePage.getLayout = (page: ReactElement) => (
  <PlainLayout
    meta={{
      title: 'open.knowledge.meta.title',
      description: 'open.knowledge.meta.description',
    }}
  >
    {page}
  </PlainLayout>
);

const stylePage = css({
  width: '100%',
  overflow: 'hidden',
});

export default OpenKnowledgePage;
